export const useNavigation = () => {
  const navigationStore = useNavigationStore()
  const { navigation } = storeToRefs(navigationStore)
  const { $api } = useNuxtApp()

  const load = async () => {
    const { data }: { data:Ref<NavigationItem[]> } = await useAsyncData('navigation', () => $api('navigation'))
    if (data.value) {
      navigation.value = unref(data.value).map(item => {
        item.validFromTimestamp = item.validFrom ? Date.parse(item.validFrom) : null
        item.validUntilTimestamp = item.validUntil ? Date.parse(item.validUntil) : null

        if (item.subItems?.length && item.subItems?.length > 0) {
          item.subItems = item.subItems.map((subItem:NavigationItem) => {
            subItem.validFromTimestamp = subItem.validFrom ? Date.parse(subItem.validFrom) : null
            subItem.validUntilTimestamp = subItem.validUntil ? Date.parse(subItem.validUntil) : null

            return subItem
          })
        }
        if (item.highlights?.length > 0) {
          item.highlights = item.highlights.map((subItem:NavigationItem) => {
            subItem.validFromTimestamp = subItem.validFrom ? Date.parse(subItem.validFrom) : null
            subItem.validUntilTimestamp = subItem.validUntil ? Date.parse(subItem.validUntil) : null

            return subItem
          })
        }
        return item
      })
    }
  }

  const getCategoryBySlug = (categorySlug: string) => {
    if (!navigation.value?.length) { return false }
    return navigation.value.find(item => item.slug === categorySlug)
  }

  const getSubCategoryBySlug = (categorySlug:string, subcategorySlug:string) => {
    if (!navigation.value?.length) { return false }

    const nav = navigation.value.find(item => item.slug === categorySlug)
    if (subcategorySlug && nav?.subItems?.length) {
      return nav.subItems.find(subItem => {
        return subItem.slug === `${categorySlug}/${subcategorySlug}`
      })
    }

    return nav
  }

  return { load, navigation, getCategoryBySlug, getSubCategoryBySlug }
}
